/**
 * Watch Pick tracking — reuses GTM-54HD5CKS custom events.
 *
 * Shopify best practice: publish via Shopify.analytics so a Customer Events
 * pixel can forward into GTM (works on storefront; checkout pixels stay
 * sandboxed). Also push dataLayer for a web GTM container in page context.
 *
 * Customer Events pixel (Settings → Customer events) should include:
 *   analytics.subscribe('all_custom_events', function (event) {
 *     window.dataLayer = window.dataLayer || [];
 *     var payload = Object.assign({ event: event.name }, event.customData || {});
 *     window.dataLayer.push(payload);
 *   });
 */
(function (window) {
  var PATH = window.location.pathname;
  var __viewedOnce = {};

  function assign(target, source) {
    if (!source) return target;
    Object.keys(source).forEach(function (key) {
      var value = source[key];
      if (value !== undefined && value !== null && value !== '') target[key] = value;
    });
    return target;
  }

  function parseMoney(value) {
    if (typeof value === 'number') return value;
    var n = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function market() {
    return window.TWS_MARKET || {};
  }

  function track(eventName, payload) {
    if (!eventName) return;
    var data = assign(
      {
        tws_page_path: PATH,
        tws_page_url: window.location.href,
        page_path: PATH,
      },
      payload
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(assign({ event: eventName }, data));
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try {
        Shopify.analytics.publish(eventName, data);
      } catch (err) {
        /* analytics.js not ready */
      }
    }
  }

  function fromElement(el) {
    var payload = {};
    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name.indexOf('data-tws-') !== 0 || attr.name === 'data-tws-event') return;
      var key = attr.name.slice(9).replace(/-/g, '_');
      payload[key] = attr.value;
    });
    return payload;
  }

  function watchRollContext() {
    var picker = document.querySelector('watch-roll-picker');
    var slots = picker && picker.slots ? picker.slots.filter(Boolean) : [];
    return {
      entry_mode: picker && picker.entryMode ? picker.entryMode : '',
      selected_watch_count: slots.length,
      tws_has_watch_selected: slots.length > 0 ? 'true' : 'false',
    };
  }

  function textTrim(el) {
    if (!el) return '';
    var innerLabel = el.querySelector('[class*="__label"]');
    var targetText = innerLabel ? innerLabel.textContent : el.textContent;
    return (targetText || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeTier(planKey) {
    if (!planKey) return '';
    var k = String(planKey).toLowerCase();
    if (k === 'yearly') return 'annual';
    return k;
  }

  function viewOnce(key, fn) {
    if (__viewedOnce[key]) return;
    __viewedOnce[key] = true;
    fn();
  }

  function observeInView(selector, eventName, extra, threshold) {
    if (!window.IntersectionObserver) return;
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id || entry.target.className || selector;
          viewOnce(eventName + ':' + id, function () {
            track(eventName, assign({ element: selector }, extra || {}));
          });
          io.unobserve(entry.target);
        });
      },
      { threshold: threshold == null ? 0.35 : threshold }
    );
    nodes.forEach(function (node) {
      io.observe(node);
    });
  }

  function initCompareTipHover() {
    document.querySelectorAll('.cmp2__tip-trigger').forEach(function (trigger) {
      if (trigger.__twsCompareTipHover) return;
      trigger.__twsCompareTipHover = true;
      trigger.addEventListener('pointerenter', function () {
        var now = Date.now();
        if (trigger.__twsCompareTipAt && now - trigger.__twsCompareTipAt < 800) return;
        trigger.__twsCompareTipAt = now;
        track(
          'clicked_compare_tooltip',
          assign(fromElement(trigger), {
            link_text: textTrim(trigger).slice(0, 120) || "What's this?",
            section: 'compare',
            interaction: 'hover',
          })
        );
      });
    });
  }

  function initTestimonialCarousel() {
    var root = document.querySelector('.membership-testimonials');
    if (!root) return;
    var fired = false;
    function fire(interactionType) {
      if (fired) return;
      fired = true;
      track('interacted_testimonial_carousel', {
        interaction_type: interactionType || 'interact',
      });
    }
    root.addEventListener(
      'touchstart',
      function () {
        fire('touch');
      },
      { passive: true }
    );
    root.addEventListener('click', function () {
      fire('click');
    });
    var viewport = root.querySelector('.membership-testimonials__viewport');
    if (viewport) {
      viewport.addEventListener(
        'scroll',
        function () {
          fire('scroll');
        },
        { passive: true }
      );
    }
  }

  function initEngagement() {
    observeInView('.wp-promo', 'viewed_promo_banner', { banner_type: 'promo_strip' });
    observeInView('.hero__lineup-tag', 'viewed_promo_banner', { banner_type: 'hero_badge' });
    observeInView('.hero__mobile-offer', 'viewed_promo_banner', { banner_type: 'mobile_offer' });
    observeInView('section.cmp2', 'viewed_buybox', {});
    observeInView('.hero__countdown', 'viewed_countdown_timer', { timer_location: 'hero' });

    initCompareTipHover();
    initTestimonialCarousel();
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target && event.target.closest ? event.target.closest('[data-tws-event]') : null;
      if (el) {
        track(el.getAttribute('data-tws-event'), fromElement(el));
        return;
      }

      var footerLink = event.target.closest('.wp-legal__link, .legal-footer__links a');
      if (footerLink) {
        track('clicked_footer_link', { link_text: textTrim(footerLink).slice(0, 120) });
        return;
      }

      var drawCard = event.target.closest('.draw-card');
      if (drawCard && !event.target.closest('a, button')) {
        var drawType = 'unknown';
        if (drawCard.classList.contains('draw-card--current')) drawType = 'current';
        else if (drawCard.classList.contains('draw-card--next')) drawType = 'next';
        track('clicked_draw_preview_card', { draw_type: drawType });
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target ||
        !event.target.matches ||
        !event.target.matches('.plans-section input[name="product"]')
      ) {
        return;
      }
      track('selected_plan_card', {
        tier: normalizeTier(event.target.getAttribute('data-plan') || ''),
      });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEngagement);
  } else {
    initEngagement();
  }

  window.twsTrack = track;
  window.twsTrackMoney = parseMoney;
  window.twsTrackMarket = market;
  window.twsTrackWatchRoll = watchRollContext;
})(window);
